import { SnackbarProvider } from 'notistack';

export const NotistackProvider = ({ children }) => (
  <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={3000}>
    {children}
  </SnackbarProvider>
);
